import * as React from 'react';
import fetch from 'cross-fetch';
import { useParams } from 'react-router-dom';
import { env } from '../../../__config__/env';

export const useCheckActiveOffice = () => {
  const params = useParams<{ sguid: string }>();
  const [active, setActive] = React.useState(false);

  const checkIfActiveOffice = React.useCallback(async () => {
    const request = await fetch(
      `${env.DS}/api/external/active/office/${params.sguid}?key=74GyzLad7wGJBxVV8tNDGbK8w3Qm6UzXhF`
    );
    if (request.status === 200) {
      const json = await request.json();
      if (json && json.active) {
        setActive(true);
      }
    }
  }, [params.sguid]);

  React.useEffect(() => {
    checkIfActiveOffice();
  }, []);

  return {
    active: active,
  };
};
